import { Input, FormLabel, FormControl, TextField, FormControlLabel, Radio, MenuItem, Select } from '@mui/material';
import styled from 'styled-components';
import { colors, fontFamilyPrimary, fontSize, fontWeight } from '../../theme';
import { ButtonWithoutBackgroundStyled } from '../../theme/style';

export const InputStyled = styled(Input)`
    && {
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        background-color: ${colors.grey000};
        border-radius: 8px;
        padding: 10px 16px;
        margin-top: 8px;
        color: ${colors.grey100};
        width: 70%;
        display: block;
        &::before {
            border: none;
        }
        &::after {
            border: none;
        }
        &:hover::after {
            border: none;
        }
        &:hover:not(.Mui-disabled):before {
            border: none;
        }
        & ::placeholder {
            color: ${colors.grey400};
            font-size: ${fontSize.sm};
            opacity: 1;
        }
    }
`;

export const NumberInputStyled = styled(Input)`
    && {
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        background-color: ${colors.grey000};
        border-radius: 8px;
        padding: 10px 16px;
        margin-top: 8px;
        color: ${colors.grey100};
        width: fit-content;
        display: block;
        margin: 10px 0px;
        &::before {
            border: none;
        }
        &::after {
            border: none;
        }
        &:hover::after {
            border: none;
        }
        &:hover:not(.Mui-disabled):before {
            border: none;
        }
        & ::placeholder {
            color: ${colors.grey400};
            font-size: ${fontSize.sm};
            opacity: 1;
        }
    }
`;

export const FormLabelStyled = styled(FormLabel)`
    && {
        color: ${colors.grey200};
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        font-weight: ${fontWeight.regular};
        margin-top: 12px;
        & span {
            color:${colors.grey400};
        }
        &.Mui-focused {
            color:  ${colors.grey200};
        }
    }
`;

export const StyledFormControl = styled(FormControl)`
    && {
        width: 100%;
    }
`;

export const StyledFormContainer = styled.div`
    && {
        max-height: 90%;
        overflow-y: auto;
        &&::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 7px;
        }
        &&::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background-color: ${colors.grey600};
            }
    }
`;

export const StyledFormGrid = styled.div`
    display: flex;
    gap: 0 24px;
    align-items: flex-start;
`;

export const StyledFormGridItem = styled.div`
    flex: 1;
`;

export const InputTitleStyled = styled(TextField)`
    && {
        border: none;
        font-weight: ${fontWeight.semiBold};
        font-size: ${fontSize.m};
        margin: 0;
        border: none;
        cursor: text;
        .Mui-disabled, .MuiInputBase-multiline {
            padding: 0;
            border: none;
            & textarea {
                -webkit-text-fill-color: ${colors.grey100};
                font-family: ${fontFamilyPrimary};
                font-weight: ${fontWeight.semiBold};
                width: 100%;
                cursor: text;
            }
            fieldset {
                border:none;
                cursor: text;
            }
        }
    }
`;

export const ButtonCopyStyled = styled(ButtonWithoutBackgroundStyled)`
    && {
        padding: 0;
        font-size: ${fontSize.m};
        &:hover {
            background: transparent;
        }
    }
`;

interface FormControlLabelStyledProps {
    ischecked: boolean
}

export const FormControlLabelStyled = styled(FormControlLabel)(({ ischecked }: FormControlLabelStyledProps) => `
    && {
        display: flex;
        & .MuiFormControlLabel-label {
            color: ${ischecked ? colors.grey100 : colors.grey300};
            font-family: ${fontFamilyPrimary};
            font-size: ${fontSize.sm};
            font-weight: ${fontWeight.regular};
        }
    }
`);

export const RadioButtonStyled = styled(Radio)`
    && {
        color: ${colors.grey500};
        &&.Mui-checked {
            color: ${colors.alertSuccess};
    }
`;

export const MenuItemStyled = styled(MenuItem)`
    && {
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.sm};
        display: flex;
        color: ${colors.grey100};

        &&.Mui-selected {
            opacity: 0.7;
        }
    }
`;

export const RequiredAsteriskStyled = styled.span`
    color: ${colors.alertDanger} !important;
    margin-left: 2px;
`;

export const SelectStyled = styled(Select)`
    && {
        font-family: ${fontFamilyPrimary};
        font-size: ${fontSize.m};
        background-color: ${colors.grey000};
        border-radius: 8px;
        width: fit-content;
        padding: 10px 16px;
        max-height: 50px;
        position: relative;
        margin: 10px 0px;
        max-width: 550px;
        justify-content: normal;
        & fieldset {
            border: none;
        }
        & .MuiSelect-select.MuiSelect-outlined {
            padding-left: 0;
        }
    }
`;

SelectStyled.defaultProps = {
    MenuProps: {
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
        transformOrigin: { horizontal: 'left', vertical: 'top' },
        PaperProps: { style: { maxHeight: 300 } },
    },
};
